// AXIS ZERO - Leaderboard Service (Stub)
// Placeholder for future leaderboard system

export class LeaderboardService {
  constructor() {
    this.localScores = this.loadLocalScores();
    this.isOnline = false; // Will be true when backend is implemented
  }

  loadLocalScores() {
    try {
      const saved = localStorage.getItem('neonStageRun_scores');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      console.warn('[LeaderboardService] Failed to load local scores:', e);
      return [];
    }
  }

  saveLocalScores() {
    try {
      localStorage.setItem('neonStageRun_scores', JSON.stringify(this.localScores));
    } catch (e) {
      console.warn('[LeaderboardService] Failed to save local scores:', e);
    }
  }

  addScore(score, playerName = 'Anonymous') {
    const entry = {
      id: Date.now().toString(),
      score: score,
      playerName: playerName,
      date: new Date().toISOString(),
    };

    this.localScores.push(entry);
    this.localScores.sort((a, b) => b.score - a.score);
    this.localScores = this.localScores.slice(0, 100); // Keep top 100
    this.saveLocalScores();

    return entry;
  }

  getHighScore() {
    return this.localScores.length > 0 ? this.localScores[0].score : 0;
  }

  getTopScores(limit = 10) {
    return this.localScores.slice(0, limit);
  }

  isNewHighScore(score) {
    return score > this.getHighScore();
  }

  // Stub for online leaderboard
  async fetchGlobalLeaderboard(limit = 10) {
    // To be implemented with backend
    console.log('[LeaderboardService] Fetch global leaderboard stub');
    return [];
  }

  async submitScoreOnline(score, playerName) {
    // To be implemented with backend
    console.log(`[LeaderboardService] Submit online stub: ${score} by ${playerName}`);
    return false;
  }

  clearLocalScores() {
    this.localScores = [];
    this.saveLocalScores();
  }
}

export default LeaderboardService;
